import { useEffect } from "react";

import { PushTopic } from "@seneca/notifications-service-types";

import { analyticsLogUserClickedOnPushNotification } from "../";
import { NotificationType } from "../consts";
import isSupportedPushAnalyticsSource from "../utils/isSupportedPushAnalyticsSource";

export default function usePushNotificationsAnalytics({
  pushSource,
  notificationType
}: {
  pushSource?: PushTopic | null;
  notificationType: NotificationType | null;
}) {
  useEffect(() => {
    if (
      isSupportedPushAnalyticsSource(pushSource) &&
      notificationType === NotificationType.PUSH
    ) {
      analyticsLogUserClickedOnPushNotification(pushSource!);
    }
  }, [pushSource, notificationType]);
}
